import MyDiv from "./employmentType.style";
import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter, FormControl, Button, Center, Spinner, Tag, TagCloseButton, TagLabel, } from "@chakra-ui/react";
import { ActionEditIcon, CustomButton, CustomTable, CustomToast, } from "../../../../../components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PlusIcon from "../../../../../assets/images/Vector.svg"
import { useFetch } from '../../../../../hooks/useFetch';
import { useEffect, useState } from 'react';
import { HrlenseInput } from '../../../../../components/Input/Input';
import { emptyEmploymentType, IEmploymentType, schema } from './modal';
import { Column } from "../../../../../components/CustomTable/customTable";


const Header = [
    { id: 1, head: "S. No" },
    { id: 2, head: "Employment type" },
    { id: 5, head: "Actions" },
];

export const EmploymentType = () => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [isEditMode, setIsEditMode] = useState(false);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [jobWorkMoods, setJobWorkMoods] = useState<IEmploymentType[]>([]);


    const { handleSubmit, control, formState: { errors }, reset, } = useForm<IEmploymentType>({
        resolver: yupResolver(schema),
        defaultValues: emptyEmploymentType,
        mode: "onBlur",
    });

    const onSubmit = async (data: IEmploymentType) => {
        const method = isEditMode ? "PUT" : "POST";
        const response = await fetchApi("RecruitmentMaster/employmentType", method, data, "", "");
        if (response) {
            addToast({ message: response.message, status: "success" })
            setDrawerOpen(false);
            reset(emptyEmploymentType);
            loadJobWorkMood()
        }
    }

    const loadJobWorkMood = async () => {
        const response = await fetchApi("RecruitmentMaster/employmentType", "GET", "", "", "");
        if (response) {
            setJobWorkMoods(response)
        }
    }

    const handleAddNewSelection = () => {
        setIsEditMode(false);
        reset(emptyEmploymentType);
        setDrawerOpen(true);
    };

    const handleEditSelection = (selections: IEmploymentType) => {
        setIsEditMode(true);
        reset(selections);
        setDrawerOpen(true);
    };

    useEffect(() => {
        loadJobWorkMood();
    }, [])

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {/* {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>
                ) : */}
                <>
                    <Flex className="page_heading flex_header">
                        <Text className="font-poppins text_semibold text_3xl">
                            Selection Terms
                        </Text>
                        <Flex gap={2}>
                            
                            <CustomButton title="Add New Selection Term" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewSelection} />
                        </Flex>
                    </Flex>
                    <Grid className="grid_container">
                        <GridItem colSpan={12}>
                            <CustomTable value={jobWorkMoods} >
                              <Column header="S. No" body={(_, index) => index + 1} />
                              <Column header="Selection Term" field="selection_Term" />
                              <Column
                                header="Actions"
                                body={(row: any) => ( <ActionEditIcon onClick={() => handleEditSelection(row)} />
                                )}
                              />
                            </CustomTable>

                        </GridItem>
                    </Grid>

                    <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="md">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px"> {isEditMode ? "Edit Employment Type" : "Add New Employment Type"}</DrawerHeader>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <DrawerBody>
                                    <Flex gap={8} mt={2}>
                                        <HrlenseInput isRequired label='Selection Term' name='selection_Term' control={control} placeholder='Enter selection Term' errors={errors} />
                                    </Flex>
                                </DrawerBody>

                                <DrawerFooter>
                                    <Button variant="outline" mr={3} onClick={() => setDrawerOpen(false)} > Cancel</Button>
                                    <Button type="submit" bg="#006838" color="white" _hover={{ bg: "#00512a" }} > {isEditMode ? "Update Employment Type" : "Add New Employment Type"} </Button>
                                </DrawerFooter>
                            </form>
                        </DrawerContent>
                    </Drawer>
                </>

            </Box>
        </MyDiv>
    )
}
